import { subHours } from "date-fns";
import React, { useCallback, useEffect, useState } from "react";
import { FiEdit3, FiTrash2, FiChevronUp, FiChevronDown } from "react-icons/fi";
import { FaClock, FaUser } from "react-icons/fa";
import { FaCheckToSlot } from "react-icons/fa6";
import { TbSearch } from "react-icons/tb";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import { PiNoteFill } from "react-icons/pi";
import { ImBlocked } from "react-icons/im";
import { MdError } from "react-icons/md";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { ReactComponent as SvgChecked } from "../../../../assets/icons/checked.svg";
import { RateTypeShippingEnum } from "../../../../enums/RateTypeShippingEnum";
import { BrComerceApiService } from "../../../../services/BrComerceApiService";
import store from "../../../../store/store";
import formatCep from "../../../../utils/FormatCep";
import { momentBDays } from "../../../../utils/MomentBDay";
import styles from "./styles.module.scss";
import ProfileEnum from "../../../../enums/ProfileEnum";
import DeliveryTypeEnum from "../../../../enums/DeliveryTypeEnum";
import ShippingStagesEnum from "../../../../enums/ShippingStagesEnum";
import { StyledTooltip } from "../../components/Tooltip";
import { addBusinessDaysIgnoreHolidays } from "../../../../utils/calculateBusinessDay";
import { formatOwnCollectStartAndEnd } from "../../../../utils/OwnCollectTime";
import { OriginEnum } from "../../../../enums/OriginEnum";
import { capitalizeFirstLetter } from "../../../../utils/CapitalizeFirstLetter";
import { DeliveryImageModal } from "../../../../components/DeliveryImageModal";

export function CartCardShipping({
  shipping,
  onExpand,
  onClick,
  isSelected,
  isExpand,
  setLoading,
  removeShipping,
  widthWindows,
  isCancelled,
  isAdmin = false,
  invoiceMethod,
  collectStage,
  edit = true,
  linkTracking = false,
  select = true,
  expand = true,
  dashDrivers = false,
  order = null,
  delivery
}) {
  const api = new BrComerceApiService();
  const { auth } = store.getState();
  const userIsAdmin = auth?.user?.profile === ProfileEnum.ADMIN.value;
  const userIsManager = auth?.user?.profile === ProfileEnum.MANAGER.value;
  const history = useHistory();

  const userHasAcess = userIsAdmin || userIsManager;

  const [deleteButton, setDeleteButton] = useState(true);

  const [showImageModal, setShowImageModal] = useState(false);
  const [dataImage, setDataImage] = useState({
    urlImage: "",
    text: ""
  });

  const handleCloseImageButton = () => {
    setDataImage({ urlImage: "", text: "" });
    setShowImageModal(false);
  };

  const handlePackage = useCallback(s => {
    if (!!s) {
      const isOwnCollect = Boolean(s?.collectTimeStart || s?.collectTimeEnd || s?.collectFrequency)

      return isOwnCollect
        ? {
          ...s,
          destination: s?.collectAddress,
          isOwnCollect: true
        }
        : {
          ...s,
          isShipping: true
        }
    }
  }, [])

  const cardData = handlePackage(shipping)

  const handleOnConfirmDelete = useCallback(() => {
    setLoading(true);
    api
      .makeHttpRequest({
        method: "DELETE",
        url: cardData.idCollect ? `shipping/${cardData.id}/cancel` : `shipping`,
        data: {
          ids: [cardData.id]
        }
      })
      .then(response => {
        removeShipping(cardData?.id);
      })
      .catch(e => {
        Swal.fire({
          icon: "error",
          title: "Ocorreu um erro!",
          text: "Não foi possível fazer a deleção do envio."
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [api, removeShipping, setLoading, cardData.id, cardData.idCollect]);

  const handleShippingCreationOrigin = useCallback(originCreation => {
    let origin;

    switch (originCreation) {
      case OriginEnum.BLINGV3:
        origin = "Bling";
        break;

      case OriginEnum.INTEGRATION:
        origin = "Integração";
        break;

      case OriginEnum.APP:
        origin = "Plataforma";
        break;

      default:
        origin = originCreation;
    }

    return capitalizeFirstLetter(origin)
  }, [])

  const handleDeleteShipping = useCallback(() => {
    Swal.fire({
      title: "Você tem certeza?",
      html:
        "Deseja prosseguir com a remoção do envio?<br>Não será possível desfazer essa ação",
      icon: "warning",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      confirmButtonText: "Sim, fazer a deleção!"
    }).then(response => {
      if (response?.value) {
        handleOnConfirmDelete();
      }
    });
  }, [handleOnConfirmDelete]);

  const addressInfoHandled = address => {
    let finalAddress = address?.street;

    if (!!address?.number) {
      finalAddress += `, ${address?.number}`;
    }

    if (!!address?.complement) {
      finalAddress += `, ${address?.complement}`;
    }

    if (!!address?.district) {
      finalAddress += `, ${address?.district}`;
    }

    return finalAddress;
  };

  const handleStatusColor = status => {
    const color = {
      [ShippingStagesEnum.ENTREGA_REALIZADA.id]: "#409E6A",
      [ShippingStagesEnum.OBJETO_EM_TRANSITO.id]: "#F5CB2B",
      [ShippingStagesEnum.OBJETO_SAIU_PARA_ENTREGA.id]: "#F5CB2B",
      [ShippingStagesEnum.OBJETO_NAO_FOI_ENTREGUE.id]: "#CA1818"
    };

    return color[status];
  };

  useEffect(() => {
    if (
      collectStage >= 2 &&
      collectStage !== 3 &&
      invoiceMethod !== "billing"
    ) {
      setDeleteButton(false);
    }
  }, [invoiceMethod, collectStage]);

  const clientName = cardData?.user?.userData[1]?.Value?.split(" ", 2).join(
    " "
  );

  return (
    <>
      {showImageModal && (
        <DeliveryImageModal
          urlImage={dataImage.urlImage}
          text={dataImage.text}
          handleCloseButton={handleCloseImageButton}
          isOpen={showImageModal}
        />
      )}
      <div
        className={`${styles.cardWrapper}
      ${cardData.blocked && styles.blockedCard} ${isCancelled &&
          styles.cancelledCard}`}
      >
        {widthWindows > 1024 ? (
          <div
            className={`${styles.cardHeader}
            ${cardData.blocked && styles.blockedShipping}`}
          >
            {cardData.blocked ? (
              <ImBlocked
                color="#CA1818"
                style={{ minWidth: "22px", minHeight: "22px" }}
              />
            ) : (
              select &&
              (isSelected ? (
                <div className={styles.containerCheck} onClick={onClick}>
                  <SvgChecked />
                </div>
              ) : (
                <div
                  className={styles.containerCheck}
                  onClick={isCancelled ? undefined : onClick}
                >
                  <div />
                </div>
              ))
            )}

            {dashDrivers && (
              <div
                style={{
                  backgroundColor: handleStatusColor(cardData.idShippingStatus)
                }}
                className={styles.dotStatus}
              />
            )}

            <div className={styles.content}>
              {dashDrivers &&
                cardData?.orderNumber !== null &&
                cardData?.orderNumber > 0 && (
                  <div className={styles.groupInfo}>
                    <div>
                      <PiNoteFill color="#409E6A" size={22} />
                      <strong className={styles.titleDescription}>
                        PEDIDO:
                      </strong>
                    </div>
                    <span className={styles.shippingInfo}>
                      {cardData?.orderCode || cardData?.orderNumber}
                    </span>
                  </div>
                )}

              {shipping?.destination?.errorObservation && shipping?.destination?.errorObservation !== null &&
                <div className={styles.groupInfoError}>
                  <div>
                    <MdError color="#ecf00b" size={22} />
                    <strong className={styles.titleDescription}>Endereço de destino inválido</strong>
                  </div>
                </div>
              }

              {userIsAdmin || userIsManager ? (
                <div className={styles.usersGroupInfo}>

                  {order !== null && (
                    <div className={styles.groupInfo}>
                      <div>
                        <strong className={styles.titleDescription}>
                          ORDEM:
                        </strong>
                      </div>
                      <span className={styles.shippingInfo}>
                        <b className={styles.shippingOrderInfo}>{order}</b>
                      </span>
                    </div>
                  )}

                  {clientName && (
                    <div className={styles.groupInfo}>
                      <div>
                        <FaUser color="#409E6A" size={18} />
                        <strong className={styles.titleDescription}>
                          CLIENTE:
                        </strong>
                      </div>
                      <span className={styles.shippingInfo} title={clientName} >{clientName}</span>
                    </div>
                  )}

                  {cardData?.destination?.name !== null && (
                    <div className={styles.groupInfo}>
                      <div>
                        <FaUser color="#409E6A" size={18} />
                        <strong className={styles.titleDescription}>
                          DESTINATÁRIO:
                        </strong>
                      </div>
                      <span className={styles.shippingInfo} title={cardData?.destination?.name}>
                        {cardData?.destination?.name}
                      </span>
                    </div>
                  )}

                  <strong>
                    {cardData?.isOwnCollect ? "Coleta Própria" : `${cardData?.correios?.nome?.replace("Entrega", "")}
                  ${cardData?.isLogisticsReverse ? " (Reversa)" : ""}
                  ${isCancelled ? " (Cancelado)" : ""}
                  `}
                  </strong>
                </div>
              ) : (
                <>
                  {cardData?.destination?.name !== null && (
                    <div className={styles.groupInfo}>
                      <div>
                        <FaUser color="#409E6A" size={18} />
                        <strong className={styles.titleDescription}>
                          DESTINATÁRIO:
                        </strong>
                      </div>
                      <span className={styles.shippingInfo} title={cardData?.destination?.name}>
                        {cardData?.destination?.name}
                      </span>
                    </div>
                  )}
                </>
              )}

              {cardData?.orderNumber !== null && cardData?.orderNumber > 0 && (
                <div className={styles.groupInfo}>
                  <div>
                    <PiNoteFill color="#409E6A" size={22} />
                    <strong className={styles.titleDescription}>PEDIDO:</strong>
                  </div>
                  <span className={styles.shippingInfo} title={cardData?.orderCode || cardData?.orderNumber}>
                    {cardData?.orderCode || cardData?.orderNumber}
                  </span>
                </div>
              )}

              {cardData?.isOwnCollect && !!cardData?.id && (
                <div className={styles.groupInfo} style={{ cursor: "pointer" }} onClick={() => window.open(`/detalhes-coleta-propria/${cardData.id}`, "_blank")} title="Abrir detalhes da coleta">
                  <TbSearch color="#409E6A" size={22} />
                  <strong className={styles.titleDescription}>COLETA:</strong>
                  <span className={styles.shippingInfo} title={cardData.id}>
                    {cardData?.id}
                  </span>
                </div>
              )}

              {cardData?.sro !== null && !!cardData?.sro && (
                <div className={styles.groupInfo}>
                  <TbSearch color="#409E6A" size={22} />
                  <strong className={styles.titleDescription}>CÓDIGO:</strong>
                  {linkTracking ? (
                    <a
                      href={`/detalhes-objeto/${cardData.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className={styles.shippingInfo} title={cardData.sro}>
                        <b>{cardData?.sro}</b>
                      </span>
                    </a>
                  ) : (
                    <span className={styles.shippingInfo} title={cardData.sro}>
                      {cardData?.sro}
                    </span>
                  )}
                </div>
              )}
              {/* {shipping?.invoiceNumber !== null &&
                !!shipping?.invoiceNumber &&
                Number(shipping?.invoiceNumber) >= 1 && (
                  <div className={styles.groupInfo}>
                    <strong className={styles.titleDescription}>
                      NOTA FISCAL:
                    </strong>
                    <span className={styles.shippingInfo}>
                      {shipping?.invoiceNumber}
                    </span>
                  </div>
                )} */}
              {/* {shipping?.rateType !== null && (
                <div className={styles.groupInfo}>
                  <strong className={styles.titleDescription}>POSTAGEM:</strong>
                  <span className={styles.shippingInfo}>
                    {shipping?.rateType === RateTypeShippingEnum.RETAIL
                      ? "Correios"
                      : "Coleta"}
                  </span>
                </div>
              )} */}


              {cardData?.authorizationCode &&
                cardData?.authorizationCode !== null && (
                  <div className={styles.groupInfo}>
                    <div>
                      <FaCheckToSlot color="#409E6A" size={22} />
                      <strong className={styles.titleDescription}>
                        AUTORIZAÇÃO:
                      </strong>
                    </div>
                    {linkTracking ? (
                      <a
                        href={`/detalhes-objeto/${cardData.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className={styles.shippingInfo} title={cardData?.authorizationCode}>
                          <b>{cardData?.authorizationCode}</b>
                        </span>
                      </a>
                    ) : (
                      <span className={styles.shippingInfo} title={cardData?.authorizationCode}>
                        {cardData?.authorizationCode}
                      </span>
                    )}
                  </div>
                )}

              {cardData?.isOwnCollect
                ? <div className={styles.groupInfo}>
                  <div>
                    <FaClock color="#409E6A" size={22} />
                    <strong className={styles.titleDescription}>HORÁRIO:</strong>
                  </div>
                  <span className={styles.shippingInfo}>
                    {formatOwnCollectStartAndEnd(cardData?.collectTimeStart, cardData?.collectTimeEnd) || "--"}
                  </span>
                </div>
                : <div className={styles.groupInfo}>
                  <div>
                    <RiMoneyDollarCircleFill color="#409E6A" size={22} />
                    <strong className={styles.titleDescription}>VALOR:</strong>
                  </div>
                  <span className={styles.shippingInfo}>
                    {new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL"
                    }).format(cardData?.price)}
                  </span>
                </div>}

              {cardData?.name ? (
                <div className={styles.groupInfo}>
                  <div>
                    <PiNoteFill color="#409E6A" size={22} />
                    <strong className={styles.titleDescription}>Nome:</strong>
                  </div>
                  <span className={styles.shippingInfo} title={cardData?.name}>
                    {cardData?.name}
                  </span>
                </div>
              ) : <></>}

              {!userHasAcess && (
                <strong>
                  {`${cardData?.correios?.nome?.replace("Entrega", "")}
                ${cardData?.isLogisticsReverse ? " (Reversa)" : ""}
                ${isCancelled ? " (Cancelado)" : ""}
                `}
                </strong>
              )}
            </div>
            <div className={styles.actionButtonsContainer}>
              {expand &&
                <div onClick={onExpand} className={styles.iconExpand}>
                  {(isExpand ? (
                    <FiChevronUp />
                  ) : (
                    <FiChevronDown />
                  ))}
                </div>
              }
              {edit &&
                (!shipping?.isValidated && !shipping?.isLogisticsReverse) && (
                  <StyledTooltip text="Editar" position="top" arrow>
                    <FiEdit3
                      className={styles.iconEdit}
                      onClick={() => {
                        if (!isCancelled) {
                          history.push(
                            `/nova-coleta/${cardData.isLogisticsReverse === true
                              ? "reverse"
                              : "normal"
                            }-send-form?shipping=${cardData?.id}`
                          );
                        }
                      }}
                    />

                  </StyledTooltip>
                )}
              {deleteButton &&
                (isAdmin ||
                  (cardData?.idCollect
                    ? !cardData?.isValidated && cardData?.idShippingStatus <= 2
                    : true)) && (
                  <StyledTooltip text="Deletar" position="top" arrow>
                    <FiTrash2
                      className={styles.iconDelete}
                      onClick={handleDeleteShipping}
                    />
                  </StyledTooltip>
                )}
            </div>
          </div>
        ) : (
          <div
            className={`${styles.cardHeaderMobile}
            ${cardData.blocked && styles.blockedShipping} ${isCancelled &&
              styles.cancelledCard}`}
          >
            {cardData.blocked ? (
              <ImBlocked
                color="#CA1818"
                style={{ minWidth: "22px", minHeight: "22px" }}
              />
            ) : (
              select &&
              (isSelected ? (
                <div className={styles.containerCheck} onClick={onClick}>
                  <SvgChecked />
                </div>
              ) : (
                <div
                  className={styles.containerCheck}
                  onClick={isCancelled ? undefined : onClick}
                >
                  <div />
                </div>
              ))
            )}
            <div className={styles.content}>
              {cardData?.orderNumber !== null && cardData?.orderNumber > 0 && (
                <div className={styles.groupInfo}>
                  <strong className={styles.titleDescription}>PEDIDO:</strong>
                  <span className={styles.shippingInfo}>
                    {cardData?.orderCode || cardData?.orderNumber}
                  </span>
                </div>
              )}
              {cardData?.name !== null && (
                <div className={styles.groupInfo}>
                  <strong className={styles.titleDescription}>{cardData?.isOwnCollect ? "COLETA" : "NOME"}:</strong>
                  <span className={styles.shippingInfo}>{cardData?.isOwnCollect ? cardData?.id : cardData?.name}</span>
                </div>
              )}
              {cardData?.invoiceNumber !== null &&
                Number(cardData?.invoiceNumber) >= 1 &&
                !!cardData?.invoiceNumber && (
                  <div className={styles.groupInfo}>
                    <strong className={styles.titleDescription}>
                      NOTA FISCAL:
                    </strong>
                    <span className={styles.shippingInfo}>
                      {cardData?.invoiceNumber}
                    </span>
                  </div>
                )}

              {cardData?.isOwnCollect
                ? (<div className={`${styles.groupInfo} ${styles.collectTime}`}>
                  <div>
                    <strong className={styles.titleDescription}>HORÁRIO:</strong>
                  </div>
                  <span className={styles.shippingInfo}>
                    {formatOwnCollectStartAndEnd(cardData?.collectTimeStart, cardData?.collectTimeEnd) || "--"}
                  </span>
                </div>)
                : (<div className={styles.groupInfo}>
                  <strong className={styles.titleDescription}>VALOR:</strong>
                  <span className={styles.shippingInfo}>
                    {new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL"
                    }).format(cardData?.price)}
                  </span>
                </div>)}
            </div>
            <div className={styles.actionButtonsContainer}>
              <strong className={styles.shippingType}>
                {
                  cardData?.isOwnCollect ? "Coleta Própria" : `${shipping?.correios?.nome?.replace("Entrega", "")}${isCancelled ? " (Cancelado)" : ""
                    } ${shipping?.isLogisticsReverse ? " (Reversa)" : ""}`
                }
              </strong >
              <div style={{ display: "flex", gap: "8px" }}>
                {expand &&
                  (isExpand ? (
                    <div onClick={onExpand}>
                      <FiChevronUp className={styles.iconOpenClose} />
                    </div>
                  ) : (
                    <div onClick={onExpand}>
                      <FiChevronDown className={styles.iconOpenClose} />
                    </div>
                  ))}
                {(!shipping?.isValidated && !shipping?.isLogisticsReverse) && (
                  <StyledTooltip text="Editar" position="top" arrow>
                    <FiEdit3
                      className={styles.iconEdit}
                      onClick={() => {
                        if (!isCancelled) {
                          history.push(
                            `/nova-coleta/send-form?shipping=${cardData?.id}`
                          );
                        }
                      }}
                    />
                  </StyledTooltip>
                )
                }
                {
                  deleteButton &&
                  (isAdmin ||
                    (cardData?.idCollect
                      ? !cardData?.isValidated && cardData?.idShippingStatus <= 2
                      : true)) &&
                  invoiceMethod === "billing" && (
                    <StyledTooltip text="Deletar" position="top" arrow>
                      <FiTrash2
                        className={styles.iconDelete}
                        onClick={handleDeleteShipping}
                      />
                    </StyledTooltip>
                  )
                }
              </div >
            </div >
          </div >
        )
        }

        <div className={!isExpand ? styles.cardBodyHidden : styles.cardBody}>
          {cardData?.isShipping && !!cardData?.origin && <div
            className={
              !isExpand ? styles.cardContentHidden : styles.cardContent
            }
          >
            <h3>REMETENTE</h3>
            <div className={styles.collectInfo}>
              <p className={styles.highlighted}>
                <span className={styles.highlighted}>Nome:</span>
                {cardData?.origin?.name}
              </p>
              <p>
                <span className={styles.highlighted}>CEP:</span>
                {formatCep(cardData?.origin?.zip)}
              </p>

              <p>
                <span className={styles.highlighted}>Endereço:</span>
                {addressInfoHandled({
                  street: cardData?.origin?.street,
                  number: cardData?.origin?.number,
                  complement: cardData?.origin?.complement,
                  district: cardData?.origin?.district
                })}
                - {`${cardData?.origin?.city}/${cardData?.origin?.state}`}
              </p>
            </div>
          </div>}

          <div
            className={
              !isExpand ? styles.cardContentHidden : styles.cardContent
            }
          >
            <h3>{cardData?.isOwnCollect ? "END. DE COLETA" : "DESTINATÁRIO"}</h3>
            <div className={styles.collectInfo}>
              <p className={styles.highlighted}>
                <span className={styles.highlighted}>Nome:</span>
                {cardData?.destination?.name}
              </p>
              <p>
                <span className={styles.highlighted}>CEP:</span>
                {formatCep(cardData?.destination?.zip)}
              </p>

              <p>
                <span className={styles.highlighted}>Endereço:</span>
                {addressInfoHandled({
                  street: cardData?.destination?.street,
                  number: cardData?.destination?.number,
                  complement: cardData?.destination?.complement,
                  district: cardData?.destination?.district
                })}
                -{" "}
                {`${cardData?.destination?.city}/${cardData?.destination?.state}`}
              </p>
            </div>
          </div>

          {cardData?.isShipping && <div
            className={
              !isExpand ? styles.cardContentHidden : styles.cardContent
            }
          >
            <h3>PACOTE</h3>
            <div className={styles.collectInfo}>
              {shipping?.originCreation && <p>
                <span className={styles.highlighted}>Origem:</span>
                {`${handleShippingCreationOrigin(shipping?.originCreation)}`}
              </p>}

              {shipping?.created_at && <p>
                <span className={styles.highlighted}>Criado em:</span>
                {`${momentBDays(shipping?.created_at)?.format("DD/MM/YYYY")}`}
              </p>}
              <p>
                <span className={styles.highlighted}>Peso total:</span>
                {`${String(cardData?.weight)?.replace(".", ",")}kg`}
              </p>

              <p>
                <span className={styles.highlighted}>Envio com seguro:</span>
                {cardData?.insurance ? "Sim" : "Não"}
              </p>
              <p className={styles.highlighted}>
                <span className={styles.highlighted}>Previsão de entrega:</span>
                {cardData?.previewDate
                  ? momentBDays(cardData?.previewDate).format("DD/MM/YYYY")
                  : momentBDays(addBusinessDaysIgnoreHolidays(
                    cardData?.correios?.desconto > 0
                      ? Number(cardData?.correios?.prazoEntrega) + 2
                      : Number(cardData?.correios?.prazoEntrega),
                    cardData.destination.state
                  ))
                    .format("DD/MM/YYYY")}
              </p>

              <p>
                <span className={styles.highlighted}>Postagem:</span>
                {cardData?.rateType === RateTypeShippingEnum.RETAIL
                  ? "Correios"
                  : "Coleta"}
              </p >
              <p>
                <span className={styles.highlighted}>Peso total:</span>
                {`${String(cardData?.weight)?.replace(".", ",")}kg`}
              </p>
            </div >
          </div >}
          {cardData?.isOwnCollect && delivery?.urlImage && (
            <div className={!isExpand ? styles.cardContentHidden : styles.cardContent}>
              <h3>EVIDÊNCIA DA COLETA</h3>
              <div className={styles.collectInfo}>
                <p>
                   <span className={styles.highlighted}>Assinado por:</span>
                   {delivery.signed_by || "--"}
                </p>
                <p>
                   <span className={styles.highlighted}>Documento:</span>
                   {delivery.document || "--"}
                </p>
                
                <div style={{ marginTop: '10px' }}>
                  <img
                    src={delivery.urlImage}
                    alt="Evidência da coleta"
                    style={{ 
                      width: '100px', 
                      height: '100px', 
                      objectFit: 'cover', 
                      borderRadius: '8px', 
                      cursor: 'pointer',
                      border: '1px solid #ddd'
                    }}
                    onClick={() => {
                      setDataImage({
                        urlImage: delivery.urlImage,
                        text: "Evidência de Coleta"
                      });
                      setShowImageModal(true);
                    }}
                  />
                </div>
              </div>
            </div>
          )}

          {/* <div
            className={
              !isExpand ? styles.cardContentHidden : styles.cardContent
            }
          >
            <h3>INFORMAÇÕES ADICIONAIS</h3>
            <div className={styles.collectInfo}>
              <span className={styles.highlighted}>Nota fiscal:</span>
              <span className={styles.handleInvoice}>Gerar nota fiscal</span>
            </div>
          </div> */}
        </div >
      </div >
    </>
  );
}

function cardShippingAreEqual(prevShipping, nextShipping) {
  const shippingHasSameCheckEqual =
    prevShipping.isSelected === nextShipping.isSelected;

  const widthWindowIsEqual =
    prevShipping.widthWindows === nextShipping.widthWindows;

  return shippingHasSameCheckEqual && widthWindowIsEqual;
}
export const CartCardShippingComponent = React.memo(
  CartCardShipping,
  cardShippingAreEqual
);
